export const meanScore = (tracks) =>
  tracks.length ? Math.round(tracks.reduce((a, t) => a + (t.completeness_score ?? 0), 0) / tracks.length) : 0;

export const projectMeta = (p) => {
  const year = (p.release_date || "").slice(0, 4);
  return [String(p.type || "album").toUpperCase(), year].filter(Boolean).join(" · ");
};

export default function ProjectGrid({ projects, tracksByProject, onOpen }) {
  if (!projects.length) return null;
  return (
    <div className="project-grid" data-testid="project-grid">
      {projects.map((p, i) => {
        const trs = tracksByProject[p.id] || [];
        const score = meanScore(trs);
        return (
          <button
            key={p.id}
            className="project-card"
            style={{ animationDelay: `${Math.min(i, 12) * 30}ms` }}
            onClick={() => onOpen(p)}
            data-testid={`project-card-${p.id}`}
          >
            <div className="project-cover" style={{ background: p.cover_art_url ? `url("${p.cover_art_url}") center/cover` : undefined }}>
              {!p.cover_art_url && <span className="serif">{(p.title || "?").slice(0, 1)}</span>}
            </div>
            <div className="project-card-title serif">{p.title}</div>
            <div className="project-card-meta mono">{projectMeta(p)}</div>
            <div className="project-card-meta mono" style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{trs.length} TRK</span>
              <span style={{ color: score >= 100 ? "var(--green-light)" : "var(--text-mute)" }} data-testid={`project-score-${p.id}`}>{score}%</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
